export default __webpack_public_path__ + "static/media/Versions - Comparisons_03.a44812a1.jpg";